import React from "react";
import "./ButtonDownloadCV.css";
import {Link} from "react-router-dom";

function ButtonSecondaryLarge(props) {
  const { downloadLink, fileName, children, className } = props;

  return (
      <Link to="#" onClick={(e) => {
          const link = document.createElement("a");

          link.href = downloadLink;
          link.download = fileName;
          link.click();
          e.preventDefault();
      }}>
          <div className={`button-secondary-large border-1px-primaryblue ${className || ""}`}>
              <div className="secondary valign-text-middle sourcesanspro-semi-bold-cerulean-18px">{children}</div>
          </div>
      </Link>
  );
}

export default ButtonSecondaryLarge;
